<template>
  <div class="KvListor">
    <div class="tags">
      <div
        class="tag"
        v-for="hay in haystack"
        @click="$emit('select', hay.id)"
        :class="selected(hay.id) ? 'is-primary' : ''"
        :key="hay.id"
      >
        {{ hay.name }}
        <span class="delete is-small" @click="deleteItem(hay.id)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/kv";
import { kvChangeKey } from "../../store/models/_helpers";
import { flowTypes, FlowItem } from "../../util/flowNotifications";
import { types as f } from "../../store/actions/flow";
import { KV_LIST_FRENCH } from "../../store/actions/kv";

export default {
  name: "KvListor",
  props: {
    type: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      haystack: []
    };
  },
  computed: {
    selectionMap() {
      if (!this.selection) return {};
      return this.selection.reduce((acc, s) => {
        acc[s] = 1;
        return acc;
      }, {});
    }
  },
  methods: {
    selected(id) {
      if (!this.selection) return false;
      return !!this.selectionMap[id];
    },
    async fetch() {
      this.haystack = (await this.$store.dispatch(t.GET_KV, this.type)).sort(
        (a, b) => (a.slug < b.slug ? -1 : 1)
      );
    },
    async deleteItem(id) {
      await this.$store.dispatch(t.DELETE_KV, { type: this.type, id });
      this.$store.dispatch(
        f.ADD_FLOW_ITEM,
        FlowItem({
          type: flowTypes.F_INFO,
          message: `Vous avez supprimé un item de "${
            KV_LIST_FRENCH[this.type]
          }"`
        })
      );
      this.$root.$emit(kvChangeKey(this.type));
    }
  },
  mounted() {
    this.fetch();
    this.$root.$on(kvChangeKey(this.type), this.fetch);
  },
  beforeDestroy() {
    this.$root.$off(kvChangeKey(this.type), this.fetch);
  }
};
</script>

<style lang="scss">
.KvListor {
}
</style>
